import { Breadcrumbs } from "@material-tailwind/react";
import { Link } from "react-router-dom";
 
type BreadcrumbProps = {
  text1: string;
  link1: string;
  text2?: string;
  link2?: string;
};

export function Breadcrumb({ link1, link2, text1, text2 }: BreadcrumbProps) {
  return (
    <Breadcrumbs placeholder={""} className="">
      <Link to="/" className="opacity-60">
        Trang chủ
      </Link>
      <Link to={`/${link1}`}>{text1}</Link>
      <Link to={`/${link2}`}>{text2}</Link>
    </Breadcrumbs>
  );
}
